var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoninBookLightMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1203",
    "data-name": "Group 1203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 29.399,
    viewBox: "0 0 150 29.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1640",
    "data-name": "Rectangle 1640",
    width: 150,
    height: 29.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1619",
    "data-name": "Rectangle 1619",
    width: 5.593,
    height: 9.294,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1620",
    "data-name": "Rectangle 1620",
    width: 0.018,
    height: 0.011,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1621",
    "data-name": "Rectangle 1621",
    width: 1.351,
    height: 1.313,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1622",
    "data-name": "Rectangle 1622",
    width: 1.226,
    height: 1.313,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1623",
    "data-name": "Rectangle 1623",
    width: 1.42,
    height: 1.544,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1624",
    "data-name": "Rectangle 1624",
    width: 1.189,
    height: 1.216,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 1.234,
    height: 1.197,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1626",
    "data-name": "Rectangle 1626",
    width: 1.042,
    height: 1.009,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1627",
    "data-name": "Rectangle 1627",
    width: 1.195,
    height: 1.322,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 1.127,
    height: 1.174,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1629",
    "data-name": "Rectangle 1629",
    width: 1.411,
    height: 1.445,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 1.248,
    height: 1.347,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1631",
    "data-name": "Rectangle 1631",
    width: 5.589,
    height: 20.602,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 0.003,
    height: 0.007,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1633",
    "data-name": "Rectangle 1633",
    width: 18.307,
    height: 27.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1634",
    "data-name": "Rectangle 1634",
    width: 0.003,
    height: 0.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1635",
    "data-name": "Rectangle 1635",
    width: 0.001,
    height: 0.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1636",
    "data-name": "Rectangle 1636",
    width: 0.005,
    height: 0.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1637",
    "data-name": "Rectangle 1637",
    width: 8.524,
    height: 5.245,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1638",
    "data-name": "Rectangle 1638",
    width: 6.45,
    height: 12.997,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M159.566,29.22c-7.887,1.488-14.674-6.533-15.178-14.583-.848-10.08,8.282-17.869,17.3-13.3a12.091,12.091,0,0,1,2.461,1.726,15.672,15.672,0,0,1,5.39,6.3c2.652,5.474,1.088,12.376-3.4,15.724a11.082,11.082,0,0,1-6.577,4.131",
    transform: "translate(-120.758 0)",
    fill: "#4d80ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M12.009,45.25a4.778,4.778,0,0,1-5.121,5.011H3.51v4.195a.955.955,0,0,1-1.059,1.059H1.082A.971.971,0,0,1,0,54.456V41.122a.971.971,0,0,1,1.082-1.059H6.887a4.914,4.914,0,0,1,5.121,5.187m-3.532.022a2.074,2.074,0,0,0-2.053-2.251H3.51V47.48H6.424a2.061,2.061,0,0,0,2.053-2.208",
    transform: "translate(0 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M87.561,54.456V41.122a.971.971,0,0,1,1.082-1.059h1.369a.955.955,0,0,1,1.059,1.059v5.585h5.784V41.122a.955.955,0,0,1,1.059-1.059h1.368a.955.955,0,0,1,1.06,1.059V54.456a.955.955,0,0,1-1.06,1.059H97.914a.955.955,0,0,1-1.059-1.059v-4.9H91.071v4.9a.955.955,0,0,1-1.059,1.059H88.643a.971.971,0,0,1-1.082-1.059",
    transform: "translate(-73.26 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M285.107,54.456V41.122a.971.971,0,0,1,1.082-1.059h.795a1.458,1.458,0,0,1,1.3.662l6.2,8.521V41.122a.971.971,0,0,1,1.082-1.059h1.368A.955.955,0,0,1,298,41.122V54.456a.955.955,0,0,1-1.06,1.059h-.794a1.423,1.423,0,0,1-1.281-.662l-6.247-8.609v8.212a.955.955,0,0,1-1.059,1.059h-1.369a.971.971,0,0,1-1.082-1.059",
    transform: "translate(-238.54 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M385.236,54.456V41.122a.971.971,0,0,1,1.082-1.059h1.369a.955.955,0,0,1,1.059,1.059V54.456a.955.955,0,0,1-1.059,1.059h-1.369a.971.971,0,0,1-1.082-1.059",
    transform: "translate(-322.315 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M427.8,54.456V41.122a.972.972,0,0,1,1.082-1.059h.795a1.457,1.457,0,0,1,1.3.662l6.2,8.521V41.122a.971.971,0,0,1,1.082-1.059h1.368a.955.955,0,0,1,1.06,1.059V54.456a.955.955,0,0,1-1.06,1.059h-.794a1.423,1.423,0,0,1-1.281-.662l-6.247-8.609v8.212a.955.955,0,0,1-1.059,1.059h-1.369a.972.972,0,0,1-1.082-1.059",
    transform: "translate(-357.926 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M540.218,51.144c0,2.649-2.185,4.371-5.5,4.371H529a.971.971,0,0,1-1.082-1.059V41.122A.971.971,0,0,1,529,40.063h5.077c3.135,0,5.431,1.59,5.431,4.238a3.294,3.294,0,0,1-2.473,3.2,3.641,3.641,0,0,1,3.179,3.642m-8.785-8.3V46.6h1.854c1.987,0,2.8-.949,2.8-1.942,0-1.148-.971-1.81-2.274-1.81Zm5.342,8.035c0-1.016-.861-2.009-2.914-2.009h-2.428v3.819h3.157c1.39,0,2.185-.795,2.185-1.81",
    transform: "translate(-441.697 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M612.649,46.545a8.192,8.192,0,1,1,8.19,7.969,7.921,7.921,0,0,1-8.19-7.969m12.869,0a4.675,4.675,0,1,0-4.679,4.923,4.7,4.7,0,0,0,4.679-4.923",
    transform: "translate(-512.584 -32.275)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M722.5,46.545a8.192,8.192,0,1,1,8.19,7.969,7.921,7.921,0,0,1-8.19-7.969m12.869,0a4.675,4.675,0,1,0-4.679,4.923,4.7,4.7,0,0,0,4.679-4.923",
    transform: "translate(-604.496 -32.275)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M843.837,52.6l-2.3-4.195v6.049a.955.955,0,0,1-1.059,1.059h-1.369a.972.972,0,0,1-1.082-1.059V41.122a.972.972,0,0,1,1.082-1.059h1.369a.955.955,0,0,1,1.059,1.059v6l4.083-6.335a1.318,1.318,0,0,1,1.259-.728h1.766c.794,0,.971.441.508,1.17l-4.3,6.468,2.075,3.51c.706,1.28,1.324,1.787,2.1,1.744a3.635,3.635,0,0,0,.685-.155c.574-.176.839.066,1.1.64l.221.486a1,1,0,0,1-.6,1.456,5.2,5.2,0,0,1-1.987.375,5.128,5.128,0,0,1-4.613-3.157",
    transform: "translate(-701.154 -33.519)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M161.511,30.512a.553.553,0,0,1-.094-.27c-.009-.032-.018-.065-.027-.1-.064-.2-.136-.389-.2-.585s-.134-.408-.2-.613c-.127-.411-.236-.826-.327-1.235-.111-.5-.207-1-.3-1.5s-.168-1-.261-1.5c-.08-.43-.168-.858-.262-1.285-.112-.486-.243-.968-.385-1.446s-.287-.939-.429-1.409c-.292-.969-.593-1.934-.86-2.91-.065-.24-.136-.479-.2-.719s-.131-.487-.195-.731-.122-.486-.181-.729-.122-.5-.179-.754l-.017-.077-.019-.085-.045-.2c-.132-.589-.294-1.171-.469-1.737l-.017-.054c-.058-.186-.116-.371-.173-.552a12.054,12.054,0,0,1-.363-1.391,2.488,2.488,0,0,1-.047-.4,2.774,2.774,0,0,1,.012-.319.879.879,0,0,1,.091-.341.967.967,0,0,1,.2-.244,1.655,1.655,0,0,1,.461-.306,2.241,2.241,0,0,1,.519-.139c.192-.033.387-.04.581-.054a5.581,5.581,0,0,0,.576-.074c.246-.046.489-.1.732-.163l.709-.172c.242-.059.484-.117.724-.181s.472-.132.707-.2c.476-.147.928-.356,1.392-.535.24-.092.483-.171.73-.243s.482-.139.724-.2.488-.131.735-.182a3.729,3.729,0,0,1,.408-.054c.133-.013.265-.029.4-.051a4.289,4.289,0,0,0,.68-.2c.221-.084.437-.178.659-.258s.449-.146.678-.2a2.88,2.88,0,0,1,.4-.068c.124-.013.249-.024.373-.042l.054-.009a9.231,9.231,0,0,0,1.335-.411c.115-.041.23-.079.344-.12s.24-.086.363-.117.23-.052.346-.072.225-.03.338-.049c.155-.03.307-.071.459-.113.074-.02.149-.041.223-.06a5.091,5.091,0,0,1,.674-.128,1.118,1.118,0,0,1,.337,0,.868.868,0,0,1,.3.12.989.989,0,0,1,.28.309,3.511,3.511,0,0,1,.224.4,9.713,9.713,0,0,1,.634,2.051l.017.076c.163.726.3,1.457.459,2.183.1.441.211.88.326,1.317s.231.859.361,1.285c.141.447.285.893.418,1.322v0c.028.089.056.178.069.223l.041.133c.064.2.126.409.176.57l.006.019.048.156.012.039c.013.037.023.074.025.082l.01.033.006.02,0,.009,0,.014.019.063c.156.5.3,1,.452,1.507s.289.982.428,1.475.277,1,.409,1.508.263,1,.385,1.5c.129.533.25,1.068.367,1.6l.007.032h0l.017.077c.131.585.274,1.167.412,1.75.014.057.038.218-.061.222a.139.139,0,0,1-.1-.061.385.385,0,0,1-.077-.155c-.116-.491-.225-.985-.341-1.476s-.245-.979-.364-1.469-.244-1-.374-1.5-.281-1.01-.426-1.513c-.128-.446-.25-.894-.378-1.341-.132-.463-.272-.924-.413-1.384l0-.014v0l-.031-.1-.045-.145c-.06-.191-.121-.381-.176-.56l-.008-.025,0-.006-.016-.049c-.005-.015-.01-.03-.014-.045L176.26,15l-.036-.114-.009-.03,0-.006-.045-.145-.034-.109-.044-.141-.041-.133c-.153-.49-.3-.982-.445-1.474s-.287-.976-.421-1.467-.268-1-.376-1.513-.2-.992-.3-1.488q-.042-.208-.088-.416c-.083-.363-.17-.726-.279-1.083l-.026-.084c-.057-.176-.12-.349-.186-.522q-.071-.171-.151-.338c-.025-.048-.051-.1-.079-.142l-.05-.075q-.024-.031-.05-.06l-.027-.026-.045-.032-.046-.022a.965.965,0,0,0-.171-.04,3.2,3.2,0,0,0-.559,0c-.1.008-.208.015-.311.029s-.209.034-.3.051c-.12.022-.24.046-.359.076s-.228.067-.341.1a6.572,6.572,0,0,1-.712.167c-.47.09-.934.218-1.4.346a5.138,5.138,0,0,0-.616.2c-.1.043-.205.091-.309.135s-.2.077-.308.111c-.2.064-.4.122-.6.173s-.412.092-.62.13c-.232.044-.462.094-.689.16-.244.071-.481.163-.722.24-.113.036-.231.06-.347.085l-.349.079c-.243.055-.485.114-.726.18s-.5.142-.744.224-.467.16-.7.239c-.47.156-.941.3-1.42.431s-.962.237-1.448.334c-.247.049-.5.087-.745.124s-.471.058-.706.086l-.458.057c-.148.018-.3.033-.444.058a1.584,1.584,0,0,0-.434.147,1.246,1.246,0,0,0-.237.174.953.953,0,0,0-.123.155.758.758,0,0,0-.04.09c-.006.019-.01.039-.015.058s-.008.061-.011.092c0,.05,0,.1,0,.15.007.123.021.246.036.369s.04.244.065.365c.107.467.253.926.39,1.386.143.48.279.962.412,1.445s.277.975.4,1.465c.067.26.128.52.185.782.05.23.094.461.142.692.016.076.033.152.045.212l0,.018h0c.11.481.245.957.38,1.432s.287.962.434,1.442c.292.959.58,1.92.82,2.893.123.5.23,1,.338,1.505s.219,1,.318,1.5c.1.523.205,1.045.313,1.531l0,.014c.115.5.239,1,.389,1.5q.113.351.233.7c.079.231.156.464.245.691l.007.016a.565.565,0,0,1,.078.237c.005.063,0,.172-.072.2l-.007,0c-.072.019-.139-.06-.174-.111",
    transform: "translate(-130.744 -4.109)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M203.119,123.437a9.337,9.337,0,0,1-1,.167c-.249.059-.483.168-.738.207-.291.046-.578.11-.865.175a2.89,2.89,0,0,0-.869.292,8.3,8.3,0,0,1-.862.3,16.326,16.326,0,0,1-1.982.444c-.22.043-.42.146-.634.21-.411.117-.835.183-1.25.287-.618.167-1.234.339-1.847.524-.617.168-1.255.256-1.86.472-.621.208-1.261.355-1.888.548a3,3,0,0,1-1.278.211c-.662-.114-.925-.852-1.069-1.426a8.567,8.567,0,0,0-.258-.889.913.913,0,0,1-.082-.4c.1-.179.257.28.28.355.122.376.244.754.392,1.121a1.025,1.025,0,0,0,.434.575,1.584,1.584,0,0,0,.944.138,8.755,8.755,0,0,0,2.413-.694c.612-.186,1.251-.268,1.861-.466,1.023-.3,2.052-.593,3.087-.855a4.177,4.177,0,0,0,.949-.29c.489-.178.983-.342,1.483-.483.5-.171,1.036-.2,1.541-.345.373-.135.724-.327,1.1-.456a4.557,4.557,0,0,1,1.119-.152c.223-.054.448-.1.675-.131a4.7,4.7,0,0,0,1.313-.465,2.976,2.976,0,0,0,.505-.436.483.483,0,0,0,.116-.206,7.731,7.731,0,0,0-.444-1.992c-.044.023-.079-.052-.086-.084-.047-.2-.1-.389-.155-.582-.027-.085-.054-.17-.083-.254a.364.364,0,0,1-.02-.306c.093-.089.2.071.226.151a22.358,22.358,0,0,1,.764,3.025c.059.291.192.632-.043.882a2.132,2.132,0,0,1-.95.556,7.493,7.493,0,0,1-.939.273",
    transform: "translate(-156.152 -99.167)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M244.277,31.959a.1.1,0,0,0-.069-.03.117.117,0,0,1,.069.03M239.063,9.937a46.346,46.346,0,0,1,1.5,6.162c.518,2.128,1.19,4.215,1.764,6.328s1.111,4.236,1.573,6.352c.053.44.978,3.633.4,3.5-.142-.049-.155-.229-.14-.356-.17-1.587-.553-3.192-.874-4.746-.7-3.246-1.741-6.4-2.6-9.61-.3-1.052-.6-2.106-.8-3.183-.2-1.034-.32-2.04-.6-3.028a4.331,4.331,0,0,0-.693-1.674.809.809,0,0,1-.1-.26l.306-.109a3.1,3.1,0,0,1,.271.618",
    transform: "translate(-199.533 -7.797)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M246.6,23.2a3.678,3.678,0,0,1,.1.372c.032.137.061.274.086.413.041.224.093.447.149.668.027.105.057.21.092.313s.085.226.127.339a2.521,2.521,0,0,1,.091.32.844.844,0,0,1,.021.277.59.59,0,0,1-.209.35,1.228,1.228,0,0,1-.163.126c-.063.043-.128.085-.194.125l-.1.058.061,0a.721.721,0,0,1,.41.185,1.241,1.241,0,0,1,.234.288c.071.112.131.232.192.351.051.1.1.2.15.3a4.825,4.825,0,0,1,.277.727c.065.227.114.458.158.689s.08.47.13.7a3.586,3.586,0,0,0,.176.556,2.681,2.681,0,0,1,.1.284.653.653,0,0,1,.02.148.347.347,0,0,1-.05.175.932.932,0,0,1-.084.133.905.905,0,0,1-.161.155,1.808,1.808,0,0,1-.241.166c-.057.032-.115.06-.172.092l-.019.016a1.049,1.049,0,0,1-.2.128,1.964,1.964,0,0,1-.326.122c-.068.019-.136.036-.2.056-.047.014-.094.029-.141.041l-.036.009a.7.7,0,0,1-.231.023.236.236,0,0,1-.181-.081c-.077-.121.11-.236.2-.276.049-.022.1-.043.148-.063.092-.038.18-.085.271-.124a2.277,2.277,0,0,1,.269-.1l.065-.017.013,0,.035-.02c.046-.03.091-.062.136-.1.018-.016.037-.031.055-.048l.01-.012,0-.005,0-.01c0-.03,0-.061,0-.092a.93.93,0,0,0,0-.107,2.531,2.531,0,0,0-.123-.444,5.8,5.8,0,0,1-.146-.606c-.049-.239-.089-.48-.122-.721a6.43,6.43,0,0,0-.111-.7c-.031-.122-.061-.244-.1-.364a3.38,3.38,0,0,0-.129-.344,2.224,2.224,0,0,0-.326-.524,1.2,1.2,0,0,0-.176-.162c-.02-.013-.041-.025-.062-.036l-.042-.015-.021,0h-.04c-.087.006-.173.017-.259.028-.236.035-.473.073-.706.124-.05.011-.1.024-.149.033a.331.331,0,0,1-.266-.038c-.073-.066,0-.158.063-.2a1.076,1.076,0,0,1,.224-.1l.164-.063.052-.021c.1-.041.2-.083.3-.12.128-.047.257-.091.384-.14.041-.018.082-.037.122-.057s.077-.041.114-.063l.021-.015.016-.014c.018-.02.035-.04.052-.062l0,0c.006-.016.01-.033.014-.049a.217.217,0,0,0,0-.03c-.016-.105-.045-.209-.067-.313-.016-.076-.033-.151-.047-.227-.018-.093-.025-.188-.034-.282a5.558,5.558,0,0,0-.1-.571c-.05-.219-.1-.435-.171-.65-.073-.234-.143-.47-.2-.708-.029-.115-.056-.231-.091-.345a2.919,2.919,0,0,0-.111-.3,2.126,2.126,0,0,0-.292-.481,1.3,1.3,0,0,0-.161-.147,1.191,1.191,0,0,0-.122-.067c-.029-.011-.058-.021-.087-.03l-.039-.009h-.007l-.064.007c-.065.01-.13.022-.195.036-.137.033-.271.073-.408.1-.089.02-.178.04-.267.055a.694.694,0,0,1-.313.01.2.2,0,0,1-.042-.018.093.093,0,0,1-.037-.137.4.4,0,0,1,.2-.145c.083-.034.166-.061.252-.087a3.488,3.488,0,0,1,.376-.087c.1-.033.2-.066.3-.1.043-.018.085-.038.127-.058l.045-.026.045-.031.027-.024.02-.024c.01-.014.019-.029.028-.044l0-.014a.546.546,0,0,0,.006-.123,3.953,3.953,0,0,0-.085-.421c-.025-.1-.042-.211-.065-.316s-.045-.194-.07-.29-.054-.216-.086-.323-.069-.21-.1-.316a2.028,2.028,0,0,1-.049-.3c-.014-.124-.025-.249-.037-.373-.023-.22-.049-.441-.092-.658-.023-.115-.05-.23-.076-.344a2.2,2.2,0,0,0-.112-.358,1.456,1.456,0,0,0-.175-.284,1.2,1.2,0,0,0-.158-.146,1.359,1.359,0,0,0-.155-.088l-.059-.021q-.04-.01-.08-.017c-.035,0-.069-.008-.1-.01h-.086c-.049,0-.1.009-.147.016s-.106.018-.158.029c-.1.024-.2.049-.3.072a1.594,1.594,0,0,1-.2.036.546.546,0,0,1-.131,0q-.025-.091-.052-.181a.59.59,0,0,1,.072-.049.913.913,0,0,1,.21-.084,3.02,3.02,0,0,1,.351-.08,3.407,3.407,0,0,1,.751-.055,1.111,1.111,0,0,1,.716.293,1.69,1.69,0,0,1,.4.7,4.781,4.781,0,0,1,.155.909c.022.168.055.334.092.5.017.077.033.154.049.231s.023.18.03.244a3.766,3.766,0,0,0,.154.734c.037.119.088.234.126.353.03.094.056.19.079.286.017.069.026.14.041.209.005.026.011.052.017.077a.241.241,0,0,1-.02.189.661.661,0,0,1-.225.209q.038.01.076.023a1.22,1.22,0,0,1,.331.2,2.09,2.09,0,0,1,.261.239,1.481,1.481,0,0,1,.221.323,3.774,3.774,0,0,1,.154.351c.047.12.093.24.135.361",
    transform: "translate(-202.829 -14.019)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M267.84,106.054c.777.838.826,2.084,1.105,3.142.125.559.331,1.1-.16,1.555a2.644,2.644,0,0,1-1.077.606,3.034,3.034,0,0,1-1,.314.485.485,0,0,1-.091-.018l-.008-.05-.015-.089-.015-.089c0-.013,0-.025-.007-.039a.521.521,0,0,1,.277-.146c.491-.128,1.122-.25,1.407-.708a2.217,2.217,0,0,0-.054-.994c-.123-.573-.152-1.162-.295-1.731a2.548,2.548,0,0,0-.59-1.362,3.943,3.943,0,0,0-1.237.14,3.508,3.508,0,0,1-.493.108l-.079-.323a3.552,3.552,0,0,1,.643-.185c.538-.069,1.178-.411,1.691-.133",
    transform: "translate(-222.141 -88.643)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M272.064,139.487a.106.106,0,0,1,.076.067.12.12,0,0,1-.046.111c-.01-.059-.019-.118-.029-.177",
    transform: "translate(-227.627 -116.704)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M205.668,78.772a2.979,2.979,0,0,1-1.281-.6,8.033,8.033,0,0,1-2.693-3.583,4.643,4.643,0,0,1-.482-2.392,3.592,3.592,0,0,1,.331-1.231,4.622,4.622,0,0,1,2.05-1.407c3.073-1.192,4.354,1.755,4.417,4.334a8.865,8.865,0,0,1-.276,3.169,2.863,2.863,0,0,1-.978,1.442,1.554,1.554,0,0,1-1.087.269m.48-.546a2.2,2.2,0,0,0,1.091-1.165,5.527,5.527,0,0,0,.472-2.921,11.162,11.162,0,0,0-.147-1.568,5.161,5.161,0,0,0-.73-1.906,1.489,1.489,0,0,0-1.172-.724A3.887,3.887,0,0,0,201.9,71.26a3.085,3.085,0,0,0-.121,2.836,7.218,7.218,0,0,0,2.674,3.669,2.8,2.8,0,0,0,1.7.462",
    transform: "translate(-168.328 -57.969)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M196.661,70.737c-.153,0-.306,0-.458,0-.136,0-.272-.008-.408-.016l-.369-.023a5.083,5.083,0,0,1-.614-.272c-.2-.107-.4-.223-.593-.347s-.387-.259-.57-.4c-.091-.071-.179-.144-.265-.218s-.17-.159-.251-.241c-.155-.157-.3-.326-.44-.494a6.359,6.359,0,0,1-.4-.531,11.308,11.308,0,0,1-.709-1.2,11.539,11.539,0,0,1-.528-1.214,9.855,9.855,0,0,1-.383-1.324,4.14,4.14,0,0,1-.059-1.348c.012-.114.029-.227.047-.341s.047-.224.076-.335a5.8,5.8,0,0,1,.5-1.243q.152-.286.332-.558c.119-.18.25-.353.385-.521a5.441,5.441,0,0,1,.469-.519,4.238,4.238,0,0,1,.5-.417c.181-.127.373-.24.564-.35a5.986,5.986,0,0,1,.922-.448c.155-.057.315-.1.475-.142q.264-.068.531-.123c.041-.008.087.034.112.061a.447.447,0,0,1,.092.166c.023.072.049.224-.054.245-.081.017-.163.035-.224.049q-.272.066-.54.146c-.184.055-.364.119-.543.189a6.658,6.658,0,0,0-1.021.5c-.075.048-.15.1-.221.149s-.142.112-.21.171c-.15.13-.292.265-.416.4l-.077.087c-.086.1-.169.2-.251.307s-.17.212-.245.324c-.15.225-.288.455-.416.693-.087.171-.171.343-.242.521s-.137.372-.2.561c-.026.1-.051.2-.073.294s-.033.192-.047.287c-.02.16-.033.318-.041.479v.036c0,.038,0,.075,0,.111,0,0,0,.008,0,.012h0c0,.1.008.2.016.3s.027.2.044.3c.044.229.093.456.151.682.055.191.116.379.179.565l0,.012v0l.011.03.026.072,0,.01,0,.009.01.026.008.021.005.015c.07.187.149.369.23.551.122.257.248.51.387.759q.1.168.2.334c.067.11.142.217.214.325.11.155.224.307.342.456.076.089.152.178.235.261.1.1.2.2.28.281s.148.136.225.2.147.117.221.174c.147.109.3.213.45.313s.308.188.461.275l.006,0,0,0c.115.062.231.123.35.176s.268.111.383.153a4,4,0,0,0,.64.162c.108.015.216.026.325.041.055.008.109.016.163.027a.749.749,0,0,1,.09.027l.022.011a.108.108,0,0,1,.063.02.318.318,0,0,1,.1.123.491.491,0,0,1,.044.121h-.04",
    transform: "translate(-159.457 -48.618)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M222.34,70.324c-.134.017-.268.03-.4.038s-.262.01-.393.011-.289-.005-.434-.006-.305,0-.458,0h-.007c-.134,0-.268-.008-.4-.017l-.367-.023a.547.547,0,0,1-.068-.19c-.015-.263.119-.168.281-.114a2.921,2.921,0,0,0,2.115.076,6.524,6.524,0,0,0,1.3-1.129,6.263,6.263,0,0,0,1.248-3.851,12.8,12.8,0,0,0-1.42-5.309,3.355,3.355,0,0,0-1.473-1.534,4.9,4.9,0,0,0-1.015-.162l-.2-.013c-.151-.024-.223-.232-.205-.367.007-.03.028-.074.065-.072a5.249,5.249,0,0,1,.663.078,3,3,0,0,1,2.388,1.827,10.689,10.689,0,0,1,1.042,2.85,10.054,10.054,0,0,1,.194,5.178,4.21,4.21,0,0,1-1.686,2.29c-.2.139-.41.285-.624.416l-.137.02",
    transform: "translate(-183.906 -48.247)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M224.865,135.444h0",
    transform: "translate(-188.138 -113.322)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M216.875,58.191a17.383,17.383,0,0,0-1.857.167c-.052.008-.149-.008-.118-.083.071-.137.254-.129.385-.158.058-.118.2-.17.31-.227a2,2,0,0,1,.826-.151c.105.012.39-.044.363.129a1.429,1.429,0,0,1,.27-.012c.043.006.1.015.118.062.034.148-.184.243-.3.273",
    transform: "translate(-179.795 -48.308)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M222.029,131.357l-.181.022-.351-.005c-.153,0-.306,0-.458,0-.136,0-.272-.008-.408-.016l-.325-.02h0c-.166-.2.322-.4.48-.335a8.768,8.768,0,0,0,1.926-.086,5.393,5.393,0,0,0,.838-.309c.05-.023.156-.049.2,0,.076.155-.4.267-.5.344a3.954,3.954,0,0,1-.807.31c-.136.037-.275.067-.414.091",
    transform: "translate(-184.292 -109.254)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M219.909,126.423a5.219,5.219,0,0,1-1.467-.014,3.828,3.828,0,0,1-.706-.1c-.212-.094-.121-.3.042-.4a1.416,1.416,0,0,1,.909-.071c.278.03.554.077.833.108a3.059,3.059,0,0,0,1,.025,2.591,2.591,0,0,0,1.157-.976c.136-.142.206-.406.428-.427.091,0,.07.107.028.156a3.381,3.381,0,0,1-2.219,1.7",
    transform: "translate(-182.069 -104.225)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M186.554,38.418a.451.451,0,0,1-.461-.242,2.48,2.48,0,0,1-.314-1.416,1.094,1.094,0,0,1,.431-1.02c1.948-.843,3.792-2.114,5.954-2.325,1.929-.23,2.156-.517,2.128,1.663-.018.365.113.837-.247,1.075a.22.22,0,0,1-.246.031,4.751,4.751,0,0,0-1.365.166,21.267,21.267,0,0,0-3.4,1.063,10.783,10.783,0,0,1-1.934.655.992.992,0,0,1-.544.349m.533-.739a9.369,9.369,0,0,1,3.149-1.166,33.68,33.68,0,0,1,3.559-.751c-.11-.541-.3-1.064-.4-1.607-.057-.471-1.059-.172-1.366-.106a34.648,34.648,0,0,0-5.668,2.162,3.332,3.332,0,0,0,.189,1.051c.046.164.036.342.1.5.141-.013.286-.114.434-.084",
    transform: "translate(-155.431 -27.828)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M146.712,46.33c-.292-.071,0-.51.152-.609a2.046,2.046,0,0,1,1.254-.528,12.108,12.108,0,0,0,1.2-.265c.195-.026.674-.321.808-.159.078.157-.039.339-.132.463-.27.349-.776.293-1.157.44-.372.111-.736.254-1.1.393-.325.094-.68.4-1.025.264",
    transform: "translate(-122.645 -37.417)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M152.016,57.873a1.036,1.036,0,0,1-.473-.011c-.078-.027-.08-.12-.065-.187a1.012,1.012,0,0,1,.506-.554,6.9,6.9,0,0,1,2.01-.7,6.806,6.806,0,0,1,.7-.151c.221-.047.257.191.19.349-.192.6-.867.684-1.389.832a14.4,14.4,0,0,1-1.474.419",
    transform: "translate(-126.732 -47.078)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M155.056,69.867a4.749,4.749,0,0,1-1.471.168c-.223-.268.672-.675.862-.788a7.589,7.589,0,0,1,1.422-.613c.264-.043,1.421-.5,1.313.05-.215.746-1.466.976-2.126,1.183",
    transform: "translate(-128.47 -57.243)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M159.327,82.6c-.224.027-.891.192-.807-.208a.744.744,0,0,1,.25-.394,3.416,3.416,0,0,1,1.6-.606c.375-.053.752-.092,1.122-.175.219-.024.633-.216.5.195-.156.474-.716.52-1.118.685-.516.17-1.022.379-1.553.5",
    transform: "translate(-132.623 -67.895)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M161.518,94.548a2.219,2.219,0,0,1-.425.043c-.079,0-.162,0-.242,0-.148.1-.315.038-.266-.154a.628.628,0,0,1,.453-.467,7.41,7.41,0,0,1,2.92-.807c.164-.039.2.153.147.269-.145.454-.664.513-1.044.682-.509.161-1.021.322-1.542.437",
    transform: "translate(-134.348 -77.94)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M166.033,107.409c-.164,0-.445.064-.541-.1-.032-.249.245-.419.441-.512a8.2,8.2,0,0,1,2.024-.469c.2-.029.828-.393.7.055-.106.346-.485.424-.793.5a8.5,8.5,0,0,1-1.83.527",
    transform: "translate(-138.46 -88.823)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M170.673,119.379c-.252.057-2.469.488-2.222-.031.329-.534,2.314-.877,2.955-.9.151,0,.293.062.444.05.112-.006.1.14.076.207a.623.623,0,0,1-.452.386,3.154,3.154,0,0,1-.8.288",
    transform: "translate(-140.921 -99.101)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M173.966,130.608a13.231,13.231,0,0,1-2.3.453c-.1,0-.258.043-.333-.043-.156-.536,1.432-1.009,1.835-1.141a7.049,7.049,0,0,1,1.591-.27c.175.015.165.208.123.334a1.094,1.094,0,0,1-.914.668",
    transform: "translate(-143.339 -108.437)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M174.96,143.239a6.318,6.318,0,0,1-1.754.221c-.2-.243.209-.717.463-.765.273,0,.538-.127.815-.143a10.493,10.493,0,0,0,1.6-.35c.231-.043.951-.283.791.15-.3.644-1.293.749-1.917.887",
    transform: "translate(-144.872 -118.888)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M177.789,155.078c-.251.017-.5.022-.753.044-.355.033-.71.094-.457-.392.1-.173.3-.4.519-.353.334-.067.655-.187.982-.282a7,7,0,0,1,1.62-.385c.2-.023.446-.088.612.042.211.774-1.944,1.345-2.521,1.327",
    transform: "translate(-147.666 -128.574)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M172.735,24.651a10.69,10.69,0,0,0-1.042-2.85,3,3,0,0,0-2.388-1.827q-.171-.031-.343-.051a.511.511,0,0,0-.143-.014c-.059-.005-.118-.009-.177-.013a.047.047,0,0,0-.034.013,2.207,2.207,0,0,0-.546.073.077.077,0,0,0-.053-.012q-.267.055-.531.123c-.16.041-.319.085-.475.142a5.985,5.985,0,0,0-.922.447c-.192.11-.383.223-.564.351a4.249,4.249,0,0,0-.5.417,5.464,5.464,0,0,0-.469.52c-.135.168-.267.341-.385.521s-.23.367-.332.558a5.81,5.81,0,0,0-.5,1.243c-.029.111-.058.221-.076.335s-.035.227-.047.341a4.136,4.136,0,0,0,.059,1.348,9.84,9.84,0,0,0,.383,1.324,11.557,11.557,0,0,0,.528,1.214,11.3,11.3,0,0,0,.709,1.2,6.325,6.325,0,0,0,.4.531c.142.168.285.338.44.494.082.083.163.166.251.241s.175.148.265.218c.183.143.375.276.57.4s.391.24.593.347c.062.033.125.064.188.094a.174.174,0,0,0,.123.178,3.836,3.836,0,0,0,.706.1,5.232,5.232,0,0,0,1.467.014,2.292,2.292,0,0,0,.414-.1l.179-.02.137-.02c.213-.131.42-.276.624-.416.063-.046.125-.093.186-.141h0a.322.322,0,0,0,.045-.036,4.067,4.067,0,0,0,1.454-2.112,10.054,10.054,0,0,0-.194-5.178m-1.825-6.922c.027-2.18-.2-1.893-2.128-1.663-2.162.21-4.006,1.482-5.954,2.325a1.094,1.094,0,0,0-.431,1.02,2.482,2.482,0,0,0,.314,1.416.451.451,0,0,0,.461.241.99.99,0,0,0,.544-.349,10.8,10.8,0,0,0,1.934-.655,21.285,21.285,0,0,1,3.4-1.063,4.772,4.772,0,0,1,1.365-.166.22.22,0,0,0,.246-.031c.36-.238.229-.711.247-1.075m.887-3.687c.279.988.4,1.993.6,3.028.2,1.077.5,2.131.8,3.183.285,1.064.59,2.123.9,3.181a.09.09,0,0,0,.014.12.16.16,0,0,0,.026.019c.445,1.54.891,3.079,1.278,4.634h0q.04.161.079.322.162.664.307,1.333c.228,1.1.487,2.23.678,3.359,0,.013,0,.026.007.038.005.03.01.059.015.089l.015.089.008.05c.06.373.111.745.151,1.117-.251.107-.5.227-.754.32-.505.149-1.039.173-1.541.345-.5.141-.994.305-1.483.483a4.176,4.176,0,0,1-.949.29c-1.035.263-2.064.552-3.087.855-.609.2-1.248.281-1.86.466a8.766,8.766,0,0,1-2.413.694,1.584,1.584,0,0,1-.944-.139,1.023,1.023,0,0,1-.433-.575c-.055-.137-.107-.276-.156-.416a.26.26,0,0,0,.016-.1c.807-.216,1.768-.65,1.624-1.179-.165-.129-.415-.065-.612-.041a5.939,5.939,0,0,0-1.324.29l-.019-.057c-.08-.232-.158-.466-.233-.7q-.056-.185-.108-.372c.611-.121,1.4-.273,1.656-.833.16-.434-.56-.194-.791-.15-.35.094-.7.191-1.052.263q-.049-.2-.095-.4l0-.014c-.057-.26-.114-.53-.169-.806.245-.059.489-.122.733-.184a1.1,1.1,0,0,0,.914-.668c.042-.126.053-.319-.123-.334a7.049,7.049,0,0,0-1.592.27l-.108.035c-.076-.382-.159-.762-.242-1.142.133-.024.231-.045.273-.054a3.175,3.175,0,0,0,.8-.288.623.623,0,0,0,.452-.386c.023-.067.036-.213-.076-.207-.151.012-.293-.053-.444-.05a8.215,8.215,0,0,0-1.184.165c-.065-.3-.133-.6-.205-.892q-.051-.209-.106-.418c.138-.05.275-.1.414-.142.308-.074.687-.152.793-.5.128-.448-.5-.084-.7-.055-.218.051-.441.084-.663.116-.126-.456-.26-.911-.4-1.365l.274-.087c.38-.168.9-.228,1.044-.682.056-.116.017-.308-.146-.269-.467.067-.948.13-1.416.234-.114-.371-.228-.742-.335-1.116.133-.047.266-.094.4-.138.4-.165.961-.211,1.118-.685.131-.41-.283-.219-.5-.195-.37.083-.747.122-1.122.175l-.122.021c-.059-.22-.115-.441-.165-.663h0l0-.018c-.013-.059-.029-.135-.045-.212s-.031-.151-.046-.226c.587-.185,1.2-.454,1.345-.955.108-.545-1.048-.093-1.313-.05q-.119.034-.235.074-.037-.159-.078-.316c-.069-.268-.143-.535-.218-.8.5-.132,1.1-.247,1.28-.8.067-.158.031-.4-.19-.349a6.787,6.787,0,0,0-.7.151c-.209.053-.42.1-.63.157-.117-.423-.237-.845-.363-1.266l0-.009c.37-.115.828-.087,1.081-.414.093-.124.209-.307.132-.463-.134-.162-.613.133-.808.159q-.287.08-.577.143c-.079-.266-.153-.533-.215-.8-.025-.122-.047-.243-.065-.365s-.029-.245-.036-.369c0-.05,0-.1,0-.15,0-.031.006-.062.011-.092a.6.6,0,0,1,.014-.059.744.744,0,0,1,.04-.09.943.943,0,0,1,.123-.155,1.251,1.251,0,0,1,.236-.174,1.589,1.589,0,0,1,.435-.147c.147-.026.3-.041.444-.058s.305-.039.458-.057c.236-.028.472-.052.706-.086s.5-.074.745-.124c.485-.1.97-.206,1.448-.333s.95-.275,1.42-.431c.234-.078.467-.16.7-.239s.494-.156.744-.224.483-.125.726-.18l.349-.079c.116-.026.233-.049.346-.085.242-.077.478-.168.722-.24.227-.066.457-.116.689-.16.209-.038.415-.078.62-.13s.4-.109.6-.173c.1-.034.207-.069.308-.111s.205-.091.309-.135a5.137,5.137,0,0,1,.616-.2c.193-.054.385-.107.579-.158a3.493,3.493,0,0,1,.425.963l0,.008c.015.049.028.1.042.146l.008.027c.035.125.068.251.1.375",
    transform: "translate(-132.048 -10.478)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M250.511,28.186a6.463,6.463,0,0,1,.348,1.683.486.486,0,0,1-.116.206,2.986,2.986,0,0,1-.505.436,4.7,4.7,0,0,1-1.313.465c-.227.035-.452.077-.675.131a4.565,4.565,0,0,0-1.119.152l-.017.006a7.355,7.355,0,0,0-.14-1,8,8,0,0,0,.753-.287,2.644,2.644,0,0,0,1.077-.606c.49-.453.284-1,.16-1.555-.279-1.058-.328-2.3-1.105-3.142a.914.914,0,0,0-.4-.106q.043-.031.085-.065a.909.909,0,0,0,.16-.155.924.924,0,0,0,.084-.133.35.35,0,0,0,.05-.175.674.674,0,0,0-.02-.148,2.768,2.768,0,0,0-.1-.284,3.566,3.566,0,0,1-.176-.556c-.05-.233-.085-.469-.13-.7s-.094-.462-.158-.689a4.818,4.818,0,0,0-.277-.727c-.048-.1-.1-.2-.15-.3-.06-.119-.121-.238-.192-.351A1.236,1.236,0,0,0,246.4,20a.722.722,0,0,0-.41-.186l-.062,0,.1-.058c.066-.04.13-.082.194-.125a1.22,1.22,0,0,0,.163-.126.591.591,0,0,0,.209-.35.851.851,0,0,0-.021-.277,2.567,2.567,0,0,0-.091-.32c-.043-.113-.089-.224-.128-.339s-.065-.208-.092-.313c-.056-.221-.109-.444-.149-.669-.025-.139-.054-.276-.086-.413a3.669,3.669,0,0,0-.1-.372c-.042-.122-.089-.242-.135-.361a3.745,3.745,0,0,0-.154-.351,1.487,1.487,0,0,0-.221-.323,2.08,2.08,0,0,0-.262-.239,1.222,1.222,0,0,0-.331-.2c-.025-.009-.051-.017-.076-.023a.661.661,0,0,0,.226-.209.241.241,0,0,0,.02-.189c-.006-.026-.012-.052-.017-.077-.015-.07-.024-.14-.04-.209-.023-.1-.049-.192-.079-.286-.038-.119-.089-.234-.126-.353a3.777,3.777,0,0,1-.154-.734c-.007-.065-.012-.155-.03-.244s-.032-.154-.048-.231c-.037-.165-.069-.331-.092-.5a4.783,4.783,0,0,0-.155-.909,1.689,1.689,0,0,0-.4-.7,1.111,1.111,0,0,0-.716-.293,3.415,3.415,0,0,0-.751.055,3.023,3.023,0,0,0-.351.08c-.029.009-.059.018-.088.028q-.121-.385-.261-.763c-.021-.046-.042-.1-.065-.169.173-.042.346-.081.521-.114a6.582,6.582,0,0,0,.712-.167c.113-.035.226-.073.341-.1s.239-.054.359-.076c.091-.017.2-.036.3-.051s.208-.021.311-.029a3.245,3.245,0,0,1,.559,0,.973.973,0,0,1,.171.04l.046.022.045.032.027.026.05.06c.017.025.034.049.05.075.028.047.054.094.079.142q.081.167.151.338c.066.172.129.346.186.522l.026.084c.109.357.2.719.278,1.083q.046.208.088.416c.1.5.192.993.3,1.488s.239,1.011.376,1.513.276.979.421,1.467.292.984.445,1.474l.041.133.044.142.034.109.045.145,0,.006.01.03.036.114.057.183c0,.015.009.03.015.046l.016.049,0,.007.008.025c.055.178.116.369.176.56l.045.145.03.1v0l0,.014c.141.461.281.922.413,1.385.128.446.249.895.378,1.341.145.5.293,1.006.426,1.513s.253,1,.374,1.5.248.978.365,1.469q.029.122.057.243a.591.591,0,0,0,.047.22l.012.035c.075.326.148.653.225.978a.387.387,0,0,0,.077.155.139.139,0,0,0,.1.061h.006",
    transform: "translate(-202.161 -7.266)",
    fill: "#1b3c6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M245.658,19.142a2.18,2.18,0,0,1,.112.358c.026.115.054.229.076.344.042.218.068.438.092.658.012.124.023.249.037.373a2.05,2.05,0,0,0,.049.3c.029.106.066.211.1.316s.058.215.086.323.048.193.07.29.04.211.065.316a3.874,3.874,0,0,1,.085.421.537.537,0,0,1-.006.123l0,.014c-.009.015-.018.03-.028.044l-.02.023-.028.025-.045.031-.045.026c-.042.02-.084.04-.127.058-.1.039-.2.072-.3.1a3.486,3.486,0,0,0-.376.087c-.083.025-.163.052-.244.084-.334-1.575-.61-3.193-1.076-4.749l.1-.022c.1-.023.2-.048.3-.072.053-.011.105-.021.158-.029s.1-.012.147-.016h.086c.035,0,.069.006.1.01s.054.01.08.017l.059.021a1.356,1.356,0,0,1,.155.088,1.194,1.194,0,0,1,.158.146,1.455,1.455,0,0,1,.175.284",
    transform: "translate(-204.253 -15.542)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M261.26,80.239c.036.12.066.242.1.364a6.4,6.4,0,0,1,.111.7c.034.241.073.482.122.721a5.81,5.81,0,0,0,.146.606,2.533,2.533,0,0,1,.123.444.894.894,0,0,1,0,.107c0,.031,0,.061,0,.092l0,.01,0,.005-.01.012c-.018.017-.036.032-.055.048-.044.033-.089.065-.136.1l-.034.02-.013,0-.065.017a2.253,2.253,0,0,0-.269.1c-.091.039-.179.086-.271.124-.05.02-.1.04-.148.063a.641.641,0,0,0-.129.08c-.039.008-.078.017-.117.027-.251-1.009-.516-2.016-.793-3.014q-.208-.764-.428-1.524l.11-.025c.233-.051.47-.089.706-.124.086-.012.172-.022.259-.028h.04l.021,0,.042.015c.021.011.042.023.062.036a1.2,1.2,0,0,1,.176.162,2.233,2.233,0,0,1,.326.524,3.446,3.446,0,0,1,.129.344",
    transform: "translate(-217.022 -66.225)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M268.918,108.914a2.548,2.548,0,0,1,.59,1.362c.143.569.172,1.158.295,1.731a2.217,2.217,0,0,1,.054.994,2.164,2.164,0,0,1-1.383.7c-.156-.724-.34-1.421-.363-1.61-.215-.988-.445-1.98-.689-2.971a2.581,2.581,0,0,1,.259-.067,3.937,3.937,0,0,1,1.237-.14",
    transform: "translate(-223.744 -91.11)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M253.284,51.149c.067.214.121.431.171.65a5.48,5.48,0,0,1,.1.571c.009.095.017.189.034.283.014.076.031.152.047.227.022.1.052.207.067.313a.255.255,0,0,1,0,.029c0,.017-.009.033-.014.049l0,0q-.025.032-.052.062l-.016.014-.021.015c-.037.022-.075.043-.114.063s-.081.039-.122.057c-.127.048-.256.093-.384.14-.1.037-.2.079-.3.12l-.052.021-.164.063-.069.025c-.433-1.5-.879-2.989-1.248-4.5l-.015-.068c.039-.005.078-.012.113-.018.09-.016.178-.035.267-.055.137-.031.271-.071.408-.1.064-.014.129-.026.195-.036l.064-.007h.007l.039.009c.03.009.058.019.087.03a1.21,1.21,0,0,1,.122.067,1.3,1.3,0,0,1,.161.147,2.128,2.128,0,0,1,.293.481,2.889,2.889,0,0,1,.111.3c.035.114.062.23.092.345.06.237.13.474.2.708",
    transform: "translate(-210.107 -41.05)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M200.255,66.55c-.063-2.579-1.344-5.526-4.417-4.333a4.622,4.622,0,0,0-2.049,1.407,3.582,3.582,0,0,0-.331,1.231,4.641,4.641,0,0,0,.482,2.392,8.033,8.033,0,0,0,2.693,3.583,2.978,2.978,0,0,0,1.281.6A1.554,1.554,0,0,0,199,71.161a2.865,2.865,0,0,0,.978-1.442,8.872,8.872,0,0,0,.276-3.169m.692-1.955a10.173,10.173,0,0,1,.47,2.908,6.263,6.263,0,0,1-1.248,3.851,6.119,6.119,0,0,1-.924.861c-.085.028-.17.054-.256.078a2.977,2.977,0,0,1-.666.092c-.1-.012-.2-.025-.3-.033-.278-.031-.555-.078-.832-.108a2,2,0,0,0-.742,0l-.079-.025c-.115-.042-.25-.093-.383-.153s-.235-.114-.35-.176l0,0-.006,0c-.153-.086-.31-.174-.461-.275s-.3-.2-.45-.313c-.074-.057-.151-.112-.221-.174s-.151-.133-.225-.2-.182-.18-.28-.281c-.082-.084-.158-.172-.235-.261-.119-.148-.232-.3-.342-.456-.072-.107-.146-.214-.214-.325s-.134-.222-.2-.334c-.139-.248-.265-.5-.387-.759-.081-.182-.161-.364-.23-.551l-.005-.015-.008-.021-.01-.026,0-.009,0-.01-.026-.072-.011-.03v0l0-.012c-.063-.186-.123-.374-.179-.565-.058-.226-.107-.453-.151-.682-.017-.1-.031-.2-.044-.3s-.016-.2-.016-.3h0s0-.008,0-.012c0-.035,0-.073,0-.111v-.036c.009-.161.022-.319.041-.479.014-.1.026-.193.047-.287s.047-.2.073-.294c.058-.19.122-.377.2-.561s.155-.35.242-.521c.128-.238.265-.469.416-.693.075-.112.161-.218.245-.324s.165-.207.251-.307l.076-.087c.124-.131.266-.266.416-.4.068-.059.137-.117.21-.171s.146-.1.221-.149a6.658,6.658,0,0,1,1.021-.5c.179-.07.359-.133.543-.189s.359-.1.54-.146c.061-.014.142-.033.224-.049a.083.083,0,0,0,.044-.023c.3-.021.611-.034.914-.058a4.264,4.264,0,0,1,.881.15A3.355,3.355,0,0,1,200,62.193a10.157,10.157,0,0,1,.95,2.4",
    transform: "translate(-160.574 -50.627)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M195.025,37.3c.307-.066,1.309-.365,1.366.106.1.542.285,1.066.4,1.607a33.572,33.572,0,0,0-3.559.751,9.363,9.363,0,0,0-3.149,1.166c-.147-.031-.293.07-.434.084-.062-.158-.052-.336-.1-.5a3.337,3.337,0,0,1-.19-1.051,34.662,34.662,0,0,1,5.668-2.162",
    transform: "translate(-158.423 -31.079)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M208.4,73.752a5.161,5.161,0,0,1,.73,1.906,11.183,11.183,0,0,1,.147,1.568,5.529,5.529,0,0,1-.472,2.921,2.2,2.2,0,0,1-1.091,1.165,2.805,2.805,0,0,1-1.7-.462,7.221,7.221,0,0,1-2.674-3.669,3.085,3.085,0,0,1,.121-2.836,3.888,3.888,0,0,1,3.763-1.318,1.489,1.489,0,0,1,1.171.724",
    transform: "translate(-169.894 -61.054)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M190.346,40.727c-.215-.021-.307-.243-.383-.415a.994.994,0,0,1,.263-1.181c1.069-.95,3.809-1.788,5.245-2.044.245-.047.489-.1.733-.148a.324.324,0,0,1,.31.505c-.074.128-.3.146-.408.171-.81.186-1.613.409-2.408.652a8.7,8.7,0,0,0-2.524,1.123.859.859,0,0,0-.5.966.321.321,0,0,1-.328.37",
    transform: "translate(-158.854 -30.902)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M196.271,71.272a.168.168,0,0,1-.061-.077,6.022,6.022,0,0,1-1.445-1.933,9.079,9.079,0,0,1-.957-4.375,4.19,4.19,0,0,1,1.631-2.784,7.2,7.2,0,0,1,2.192-1.3,3.692,3.692,0,0,1,1.811-.171,3.539,3.539,0,0,1,.591.142c.168.027.344.133.3.33a.255.255,0,0,1-.3.193c-.146-.034-.294-.058-.44-.089a3.59,3.59,0,0,0-.813-.109,3.731,3.731,0,0,0-1.479.347,4.676,4.676,0,0,0-2.742,2.48,4.9,4.9,0,0,0-.025,3.765,7.2,7.2,0,0,0,1.149,2.325,11,11,0,0,1,.787.969.174.174,0,0,1-.195.287",
    transform: "translate(-162.135 -50.696)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M245.886,19.982c-.169-.077-.341-.148-.515-.211a.552.552,0,0,1-.242-.1.2.2,0,0,1,.14-.329,1.437,1.437,0,0,1,.8.251.217.217,0,0,1-.185.391",
    transform: "translate(-205.045 -16.177)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M253.716,50.529a2.016,2.016,0,0,0-.686-.313.172.172,0,0,1-.2-.091.164.164,0,0,1,.09-.218.619.619,0,0,1,.562.032,3.32,3.32,0,0,1,.453.287.188.188,0,0,1-.223.3",
    transform: "translate(-211.526 -41.709)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M262.09,80.911c-.188-.146-.419-.226-.613-.357-.126-.13.046-.285.186-.286a.739.739,0,0,1,.515.188c.086.077.217.132.238.257a.208.208,0,0,1-.326.2",
    transform: "translate(-218.733 -67.157)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M255.787,50.235a.688.688,0,0,1-.352-.245c-.129-.246.147-.35.344-.261a.446.446,0,0,1,.295.278.213.213,0,0,1-.286.228",
    transform: "translate(-213.687 -41.581)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M273.873,110.356c-.135-.095-.44-.284-.229-.453.189-.1.384.109.455.27a.151.151,0,0,1-.226.183",
    transform: "translate(-228.889 -91.932)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M212.452,116.61h0",
    transform: "translate(-177.752 -97.564)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M212.415,116.572l0,0,0,0",
    transform: "translate(-177.721 -97.532)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M212.441,116.6h0",
    transform: "translate(-177.743 -97.556)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M167.556,57.343a.487.487,0,0,1-.283-.864.7.7,0,0,1,.6-.111.383.383,0,0,1,.128.623.452.452,0,0,1-.441.351",
    transform: "translate(-139.801 -47.138)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M163.688,46.3c-.483-.24-.265-1.064.3-.918.476.009.587.8.068.843a.349.349,0,0,1-.369.075",
    transform: "translate(-136.73 -37.953)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M260.292,46.834a.5.5,0,0,1-.1-.2.2.2,0,0,1,.035-.3.191.191,0,0,1,.263.065c.476.172.139.751-.2.437",
    transform: "translate(-217.652 -38.742)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M268.694,75.956a.358.358,0,0,1-.234-.621c-.069-.262.293-.34.317-.076a.357.357,0,0,1-.083.7",
    transform: "translate(-224.519 -62.83)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M193.642,169.49h0",
    transform: "translate(-162.013 -141.807)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M193.572,169.489h0",
    transform: "translate(-161.956 -141.806)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M286.375,87.15h0",
    transform: "translate(-239.601 -72.916)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M286.359,87.106l0,0,0,0",
    transform: "translate(-239.588 -72.879)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M297.479,134.559v0",
    transform: "translate(-248.891 -112.581)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M265.019,14.908l0,.013,0-.013",
    transform: "translate(-221.733 -12.473)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M264.994,14.84v0l0,.009,0-.006",
    transform: "translate(-221.711 -12.414)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M223.843,130.834a3.066,3.066,0,0,1-1.225.03,2.18,2.18,0,0,1-1.135-.326.285.285,0,0,1-.006-.372.549.549,0,0,1,.11-.088q.09.034.182.063c.133.042.268.082.4.124a1.568,1.568,0,0,0,.832.112l.033-.008.055.006a.23.23,0,0,0,.084-.006.242.242,0,0,0,.12-.077l.211-.068a2.843,2.843,0,0,0,.409-.163,1.852,1.852,0,0,0,.387-.242c.07-.061.139-.123.205-.188a.5.5,0,0,1,.085.916,2.641,2.641,0,0,1-.7.277l-.049.013",
    transform: "translate(-185.247 -108.456)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(32.887 11.352)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M201.8,74.252c.025.128.047.257.07.385.1.246.2.492.3.736.05.111.1.222.15.334s.1.2.138.308l.079.195c.024.058.047.116.066.175l.047.054q.253.3.5.6a.146.146,0,0,1,.017.158h0l.01.01.344.329a.045.045,0,0,1,.022.011l.372.346.018.017.017.014.064.057.264.219-.019-.016.447.363.118.1.067.037h0l.091.045a.276.276,0,0,1,.206.062l.01.009a.362.362,0,0,0-.075-.429q-.122-.114-.237-.234c-.546-.738-1.261-1.322-1.745-2.117-.441-1.476-.911-2.856.024-4.279a3.515,3.515,0,0,1,1.776-1.291,8.812,8.812,0,0,1,1.148.064,2.444,2.444,0,0,0,.726.017.442.442,0,0,0,.134-.055l-.043-.035q-.143-.115-.288-.229c-.087-.068-.172-.138-.262-.2l-.324-.232-.1-.068a.331.331,0,0,1-.056.024.355.355,0,0,1-.219,0,1.59,1.59,0,0,1-.239-.1l-.144-.071c-.033-.016-.065-.034-.1-.052a5.7,5.7,0,0,0-.726.031l-.226.086c-.044.019-.087.04-.13.061-.181.1-.356.217-.539.316-.108.058-.218.113-.328.168a.5.5,0,0,1-.053.057c-.082.075-.172.141-.258.212a2.3,2.3,0,0,1-.453.326.748.748,0,0,1-.126.046.518.518,0,0,1-.289,0c-.025.03-.05.06-.074.091a3.87,3.87,0,0,0-.616,1.432.264.264,0,0,1,.159.2q.085.592.185,1.182c.031.181.068.362.1.542",
    transform: "translate(-201.352 -69.502)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(35.621 11.52)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M218.093,70.545h0l.016-.01-.018.011",
    transform: "translate(-218.093 -70.534)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(31.533 24.899)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M193.927,153.734a.633.633,0,0,0,.089-1.2.646.646,0,0,0-.925.757.679.679,0,0,0,.837.446",
    transform: "translate(-193.061 -152.448)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(31.017 23.024)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M190.927,141.133c-.7-.609-1.464.637-.717,1.073a.653.653,0,0,0,.717-1.073",
    transform: "translate(-189.903 -140.968)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(30.419 20.979)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M186.525,128.739a.7.7,0,0,0,.435,1.25.773.773,0,0,0,.47-1.331.534.534,0,0,0-.906.081",
    transform: "translate(-186.244 -128.447)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(30.029 19.089)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M183.989,117.863a.6.6,0,1,0,.723-.914.6.6,0,0,0-.723.914",
    transform: "translate(-183.851 -116.875)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(29.363 17.036)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M180.127,104.357a.6.6,0,0,0,.087,1.129.664.664,0,0,0,.791-.506.643.643,0,0,0-.878-.624",
    transform: "translate(-179.773 -104.305)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(28.86 15.16)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M177.445,92.933a.445.445,0,0,0-.741.294.523.523,0,0,0,.6.588c.439-.059.64-.753.139-.882",
    transform: "translate(-176.697 -92.815)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(28.386 13.005)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M173.97,80.736c.544.626,1.417-.292.821-.834-.475-.683-1.373.01-.821.834",
    transform: "translate(-173.796 -79.624)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(27.774 10.955)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M171.126,67.42a.561.561,0,1,0-.964.558c.31.644,1.239,0,.964-.558",
    transform: "translate(-170.049 -67.072)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(26.514 6.993)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M162.882,44.227a.71.71,0,0,0,.473-1.328.71.71,0,1,0-.473,1.328",
    transform: "translate(-162.334 -42.812)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(27.088 8.905)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M166.5,54.528c-.785-.08-.9,1.277-.108,1.341a.673.673,0,0,0,.108-1.341",
    transform: "translate(-165.849 -54.524)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(41.55 3.096)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M257.894,39.549a1.085,1.085,0,0,0,.152-.029.587.587,0,0,0,.309-.19.432.432,0,0,0,.17,0,1.947,1.947,0,0,0,1.4-1.747,6.1,6.1,0,0,0-.51-3.323c.155-.577-.864-2.148-.954-2.617a15.111,15.111,0,0,0-.852-3.009,1.249,1.249,0,0,0-.2-.289.228.228,0,0,0,.074-.179,8.754,8.754,0,0,0-.141-1.133,12.287,12.287,0,0,0-.887-3.128,2.789,2.789,0,0,0-.634-1,1.04,1.04,0,0,1-.011-.148,8.63,8.63,0,0,0-.453-2.5,2.021,2.021,0,0,1-.108-.382,2.5,2.5,0,0,0-.314-.717c-.112-.212-.442-.307-.531-.027a.606.606,0,0,0,.083.38,4.395,4.395,0,0,0,.49.987c.106.523.183,1.052.316,1.569a4.112,4.112,0,0,1,.151.627,1.486,1.486,0,0,0-.007.266.308.308,0,0,0-.116.243,3.019,3.019,0,0,0,.194.7,15.582,15.582,0,0,1,1.145,3c.1.388.2.774.292,1.164a.621.621,0,0,0-.095-.022.217.217,0,0,0-.234.294,2.544,2.544,0,0,0,.36.969c.114.343.221.687.338,1.029a6.79,6.79,0,0,1,.443,1.792c.059.3.037.863.341,1,.327,1.085.65,2.172.934,3.268a1.713,1.713,0,0,1-.882,2.092.417.417,0,0,0-.035.037.817.817,0,0,0-.41-.115.621.621,0,0,0-.417.183c0,.061.008.122.014.183.017.181.04.361.06.542,0,.035.008.07.011.1a.64.64,0,0,0,.517.12",
    transform: "translate(-254.391 -18.957)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(46.784 14.262)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M286.439,87.321l0,.008v-.008",
    transform: "translate(-286.439 -87.321)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(31.291 0.849)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M208.223,21.394a32.173,32.173,0,0,1-1-3.3c-.27-1.129-.432-2.281-.69-3.412a41.91,41.91,0,0,0-1.371-4.8c-.342-.913-.622-1.847-1.031-2.735-.275-.583-.457-1.214-.779-1.772a.429.429,0,0,0-.778.207.578.578,0,0,1,.113,0,.609.609,0,0,1,.289.136,1.115,1.115,0,0,1,.214.228,1.881,1.881,0,0,1,.193.334c.071.15.128.309.188.465l0,.013v0l0,.009,0,0h0l0,.012c.044.114.085.228.127.342.049.135.09.272.133.409l0-.009q.06.19.111.384a.282.282,0,0,1,.146.1.639.639,0,0,1,.064.1c.018.037.034.075.049.113.024.061.046.122.068.184a1.856,1.856,0,0,1,.069.25c.035.167.067.334.1.5s.053.315.074.474a1.755,1.755,0,0,1-.011.516.223.223,0,0,1-.073.127c.313.954.556,1.929.788,2.91a.371.371,0,0,1,.148.169,3.508,3.508,0,0,1,.137.392c.037.122.075.243.114.364.075.236.16.468.234.7s.139.452.2.679a7.216,7.216,0,0,0,.225.691c.055.128.112.255.161.385s.082.257.128.384.1.266.139.4.071.261.111.39c.047.148.095.295.136.444s.075.271.118.4l-.018-.049.011.03v0l0,.006h0l.006.016,0,.009,0,.006.006.017-.008-.021.03.081c.048.125.1.248.147.373s.075.246.107.37l.006.023v0h0v0l0,.017,0,.008.013.049c.031.116.062.232.091.348a2.335,2.335,0,0,1,.049.424c0-.016,0-.031,0-.047l0,.078c0,.01,0,.021,0,.031v-.008c0,.049.007.1.01.146.007.073.014.144.02.217s.017.154.025.231c0,0,0-.006,0-.009,0,.036.008.071.011.107v0c0,.011,0,.023,0,.034v-.006c0,.007,0,.014,0,.021s0,.036.006.055c.034.278.081.555.126.831.02.125.044.25.062.375l.037.246c0,.025.008.051.011.078.185.617.357,1.24.5,1.874l.038.168a.632.632,0,0,1,.075.151c.027.07.053.14.077.211h.006a.163.163,0,0,1,.136.125c0,.011.006.023.009.034a.214.214,0,0,1,.079.156c.006.068.012.136.019.2.034.323.086.643.145.963.027.126.054.253.073.38l.031.11a.28.28,0,0,1-.069.264.194.194,0,0,1-.12.079h-.005a.256.256,0,0,1-.059.009l0,.072a1.258,1.258,0,0,0-.083.108,2.628,2.628,0,0,1-.651.477,15.164,15.164,0,0,1-2.3.767c-1.335.348-2.668.706-4,1.062-1.45.415-2.9.837-4.378,1.144-1.112.225-2.224.463-3.349.6a.306.306,0,0,1-.147.124,2.557,2.557,0,0,1-.3.1l-.071.018a5.194,5.194,0,0,1-.517.114,3.124,3.124,0,0,1-.438.032c-.125,0-.25.011-.375.007-.085,0-.169-.01-.254-.011h-.013l-.084,0h.041l.043-.006a.35.35,0,0,1-.254-.049l-.026-.019a.546.546,0,0,0,.138.613,2.52,2.52,0,0,0,1.809.349c.674-.091,1.335-.259,2-.394a16.539,16.539,0,0,0,2.063-.58c1.5-.48,3.045-.818,4.583-1.16,1.282-.276,2.591-.614,3.87-.932q.382-.1.763-.2c.419-.112.836-.23,1.252-.357a2.086,2.086,0,0,0,1.388-.971,1.332,1.332,0,0,0,.2-.363,2.8,2.8,0,0,0,.088-1.813,33.447,33.447,0,0,0-1.558-4.752",
    transform: "translate(-191.582 -5.197)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(48.494 21.258)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M296.91,130.178v-.026c0,.009,0,.017,0,.026",
    transform: "translate(-296.907 -130.152)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(46.787 14.27)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M286.457,87.37h0v0",
    transform: "translate(-286.456 -87.367)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(46.779 14.249)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M286.409,87.241l0,.013,0-.005,0-.008",
    transform: "translate(-286.409 -87.241)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(30.822 5.503)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M188.876,38.694a1.809,1.809,0,0,0,1.412.183c.81-.156,1.486-.667,2.275-.894.806-.318,1.662-.465,2.481-.74a6.567,6.567,0,0,0,1.794-.6,1.4,1.4,0,0,0,.238-1.642c-.163-.418-.035-1.042-.484-1.29a.282.282,0,0,0-.4.243c.019.4.317.736.411,1.125.023.177.082.787-.1.863-.77.239-1.536.491-2.327.653-1.178.363-2.326.822-3.491,1.223a7.2,7.2,0,0,1-1.687.445.223.223,0,1,0-.13.427",
    transform: "translate(-188.706 -33.69)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(35.271 9.71)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M219.1,72.343c.054-.011.107-.024.159-.038a4.374,4.374,0,0,0,2.5-2.179,7.368,7.368,0,0,0,.621-2.91,6.869,6.869,0,0,0-.047-1.633,5.962,5.962,0,0,0-.162-.779,7.572,7.572,0,0,0-.3-.715c-.21-.488-.358-1-.525-1.5a3.955,3.955,0,0,0-.359-1.017,3.486,3.486,0,0,0-.88-1.223,3.45,3.45,0,0,0-.829-.632c-.2-.1-.424-.134-.618-.244a.24.24,0,0,0-.313.09.157.157,0,0,1,.081.039l.149.083a1.881,1.881,0,0,1,.337.269l.032.03c.057.046.112.093.167.14.123.1.239.219.356.331l.171.161c.028.026.057.052.084.08l.045.047a.748.748,0,0,1,.088.12.361.361,0,0,1,.055.2l.04.055c.071.1.137.2.2.3a4.447,4.447,0,0,1,.311.582,2.19,2.19,0,0,1,.153.44c.056.116.109.234.161.352a4.157,4.157,0,0,1,.153.42c.046.148.092.3.139.445s.1.314.14.473.069.337.1.506l0,.03c.021.1.042.208.067.312s.056.223.075.336.024.227.034.34.017.233.022.35a4.133,4.133,0,0,1,.044.571c0,.015,0,.031-.006.046s0,.033-.005.049c0,0,0,0,0-.006v.007l0,.018h0v0c-.017.157-.04.313-.054.471,0,.017,0,.035,0,.052a.211.211,0,0,1-.047.181,10.28,10.28,0,0,1-.211,1.784,3.436,3.436,0,0,1-2.016,2.279,3.938,3.938,0,0,1-.5.134.242.242,0,0,1-.1.058.225.225,0,0,1-.084.006l-.055-.007-.033.008a1.122,1.122,0,0,1-.535-.024,9,9,0,0,1-1.281-.271,1.259,1.259,0,0,0-.588-.037c-.152.063-.05.264.039.343a3.406,3.406,0,0,0,3.029.675",
    transform: "translate(-215.95 -59.446)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M250.129,103.8h0",
    transform: "translate(-209.275 -86.843)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M250.129,103.79h0",
    transform: "translate(-209.275 -86.838)",
    fill: "#011e41"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoninBookLightMobile);
export default __webpack_public_path__ + "static/media/PhoninBook-Light-Mobile.772b9ddf5599f85d56e78ecde023bd5f.svg";
export { ForwardRef as ReactComponent };